<ion-card class="card-custom" *ngIf="enabled">
  <ion-card-header has-button>
    <ion-card-title>
      {{ "feedback.dashboard.title" | translate }}
      <div class="tooltip"
        [matTooltip]="'feedback.dashboard.title.tooltip' | translate"
      >i</div>
    </ion-card-title>
    
    <ion-button
      color="lightblue"
      shape="round"
      mode="ios"
      (click)="goToFeedbacks()">
      {{ "feedback.dashboard.goToFeedbacks" | translate }}
      <span class="feedback-notification" *ngIf="unreadCount > 0">{{unreadCount}}</span>
    </ion-button>
  </ion-card-header>
  <ion-card-content class="ion-no-padding">
    <mat-accordion>
      <mat-expansion-panel *ngIf="goodPrinciples.length > 0">
        <mat-expansion-panel-header class="okrHeader">
          <mat-panel-title>
            {{ "feedback.dashboard.good" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-panel-description>
          <ion-list
            mode="ios"
            lines="full"
            class="full-width ion-no-margin goal-progress"
          >
            <ion-item *ngFor="let principle of goodPrinciples">
              <ion-label>
                <h2 style="white-space: break-spaces;">{{ getPrincipleText(principle.principle.principle) }}</h2>
              </ion-label>
              <span class="tooltip-stars">
                <div 
                  *ngFor="let item of [0, 1, 2, 3, 4]; let i = index" class="icon-custom icon-custom-star" 
                  [ngClass]="{ 'icon-custom-star-good': (i+1) <= principle.sum }"
                  [ngStyle]="{ background: i === Math.floor(principle.sum) ? 'linear-gradient(to right, var(--ion-color-success) ' + (((principle.sum - Math.floor(principle.sum)) * 100).toString() + '%') + ', gray 0%)' : null }"
                >
                </div>
              </span>
            </ion-item>
          </ion-list>
        </mat-panel-description>
      </mat-expansion-panel>
      <mat-expansion-panel *ngIf="badPrinciples.length > 0">
        <mat-expansion-panel-header class="okrHeader">
          <mat-panel-title>
            {{ "feedback.dashboard.bad" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-panel-description>
          <ion-list
            mode="ios"
            lines="full"
            class="full-width ion-no-margin goal-progress"
          >
            <ion-item *ngFor="let principle of badPrinciples">
              <ion-label>
                <h2 style="white-space: break-spaces;">{{ getPrincipleText(principle.principle.principle) }}</h2>
              </ion-label>
              <span class="tooltip-stars">
                <div 
                  *ngFor="let item of [0, 1, 2, 3, 4]; let i = index" class="icon-custom icon-custom-star" 
                  [ngClass]="{ 'icon-custom-star-bad': (i+1) < principle.sum }"
                  [ngStyle]="{ background: i === Math.floor(principle.sum) ? 'linear-gradient(to right, var(--ion-color-danger) ' + (((principle.sum - Math.floor(principle.sum)) * 100).toString() + '%') + ', gray 0%)' : null }"
                >
                </div>
              </span>
            </ion-item>
          </ion-list>
        </mat-panel-description>
      </mat-expansion-panel>
    </mat-accordion>
  </ion-card-content>
</ion-card>
